'use strict';

angular.module('portal.applications')
    .controller('PortalApplications', ['$scope', 'LicenseRequests', 'FBForms', 'FBResponses', 'Cache', '$state', '$stateParams', '$rootScope', '$window', '$filter', 'Triggers', '$timeout', 'Documents', 'Session', 'PortalPermissions',
        function ($scope, LicenseRequests, FBForms, FBResponses, Cache, $state, $stateParams, $rootScope, $window, $filter, Triggers, $timeout, Documents, Session, PortalPermissions) {
            $scope.review = $stateParams.review;
            $scope.loading = true;
            $scope.appLoading = true;
            $scope.serviceVehicleDataSet = [];
            $scope.bulkActionApplications = [];
            $scope.showBulkAction = false;
            $scope.listParams = {
                currentPage: 0,
                numPerPage: 10
            }
            $scope.statusFilterParameters = {
                publicOnly: true // hardcoded for now, get only public statuses
            }

            $scope.enterprise = $rootScope.enterprise;
            // Get the entity label
            $scope.serviceLabel = $scope.enterprise.serviceLabels["SERVICE"];
            
            Session.CheckSession().then(function (validSession) {
                $scope.appLoading = true;
                if (validSession) {
                    LicenseRequests.get({ userOnly: !$scope.review, reviewOnly: $scope.review, userId: $rootScope.userID }).then(function (applications) {
                        if (applications != null) {
                            $scope.applications = applications.records;
                            getServiceApplicationVehicles();
                        }
                        $scope.loading = false;
                    });
                }
            });

            PortalPermissions.getPermissions().then(function (portalPermissions) {
                if (portalPermissions && portalPermissions["portal.menus.reviewPayment"] && portalPermissions["portal.menus.reviewPayment"].visible) {
                    $scope.showBulkAction = true;
                }
            })

            Cache.getState('list').then(function (state) {
                if (state != null) {
                    $scope.sortBy = state.sortBy;
                    $scope.reverse = state.reverse;
                    $scope.search = state.search;
                    $scope.listParams.currentPage = state.currentPage;
                    $scope.listParams.numPerPage = state.numPerPage;
                }
                else {
                    $scope.listParams.currentPage = 0;
                    $scope.listParams.numPerPage = 10;
                }
            });

            $scope.cacheList = function () {
                var state = {
                    sortBy: $scope.sortBy,
                    reverse: $scope.reverse,
                    search: $scope.search,
                    currentPage: $scope.listParams.currentPage,
                    numPerPage: $scope.listParams.numPerPage
                }

                Cache.setState('list', state);
            }

            $scope.$watch('search', function (old, newie) {
                if (old != newie) {
                    $scope.listParams.currentPage = 0;
                    $scope.cacheList();
                }
            });

            $scope.$watch('listParams.currentPage + listParams.numPerPage + sortBy + reverse', function (old, newie) {
                if (old != newie) {
                    $scope.cacheList();
                }
            });

            $scope.clear = function () {
                $scope.search = '';
                $scope.listParams.currentPage = 0;
                $scope.cacheList();
            }

            $scope.startResponse = function (application, response) {
                response.starting = true;
                var saveResponse = angular.copy(response);
                saveResponse.progress = 1;
                saveResponse.started_on = new Date();
                FBResponses.save(saveResponse, null, false).then(function (savedResponse) {
                    if (savedResponse != null && savedResponse.form.start_trigger_name != null && savedResponse.form.start_trigger_name != "") {
                        Triggers.fire({
                            name: savedResponse.form.start_trigger_name,
                            triggerID: savedResponse.form.start_trigger_id,
                            licenseRequestID: savedResponse.license_request_id
                        });
                    }
                    $state.go('portal.menus.application', { id: application.id, application: application, responseID: response.id, response: response, review: $scope.review });
                    response.starting = false;
                });
            }

            $scope.continueResponse = function (application, response) {
                $state.go('portal.menus.application', { id: application.id, application: application, responseID: response.id, response: response, review: $scope.review });
            }

            $scope.greaterThan = function (prop, val) {
                return function (item) {
                    return item[prop] > val;
                }
            }

            $scope.formCountText = function (application) {
                var total = 0;
                var completed = 0;

                if (application.packages != null && application.packages.length > 0) {
                    application.packages.forEach(function (pack) {
                        if (pack.responses != null && pack.responses.length > 0) {
                            total += pack.responses.length;
                            completed += $filter('filter')(pack.responses, function (r) { return r.completed_On != null }).length;
                        }
                    });
                }
                if (application.responses != null && application.responses.length > 0) {
                    total += application.responses.length;
                    completed += $filter('filter')(application.responses, function (r) { return r.completed_On != null }).length;
                }

                return completed + " of " + total + " completed";
            }

            $scope.viewPdf = function (response) {
                Documents.logAccess(response.documentId);
                $window.open($rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + response.documentId.toUpperCase() + '&code=' + response.documentCode, '_blank');
            }

            var stop;
            $scope.checkApplicationTriggers = function (application) {
                if (application.currentTriggersFiringCount != null && application.currentTriggersFiringCount > 0) {
                    // check if the application was modified in the last 45 seconds first
                    if (application.modifiedOn != null && (((new Date) - application.modifiedOn) < (45 * 1000))) {
                        if (angular.isDefined(stop)) return;

                        stop = $timeout(function () {
                            LicenseRequests.get({ userOnly: !$scope.review, reviewOnly: $scope.review }).then(function (applications) {
                                stop = undefined;
                                $scope.applications = applications;
                                getServiceApplicationVehicles();
                            })
                        }, 5000);
                    }
                    else {
                        // set the trigger fire count to 0
                        application.currentTriggersFiringCount = 0;
                        LicenseRequests.setCurrentTriggerCount(application.id, 0);
                    }
                }
            }

            $rootScope.$on('generate:pdf', function () {
                $rootScope.generatingPDF = true;
            });

            $rootScope.$on('reset:application', function () {
                LicenseRequests.get({ userOnly: !$scope.review, reviewOnly: $scope.review }).then(function (applications) {
                    $rootScope.generatingPDF = false;
                    $scope.applications = applications;
                    getServiceApplicationVehicles();
                })
            });

            window.onbeforeunload = function (e) {
                if ($rootScope.generatingPDF) {
                    var message = "", e = e || window.event;
                    // For IE and Firefox
                    if (e) {
                        e.returnValue = message;
                    }
                    // For Safari
                    return message;
                }
            };

            $scope.$on('$destroy', function () {
                if (angular.isDefined(stop)) {
                    $timeout.cancel(stop);
                    stop = undefined;
                }
            });

            // Get Vehicle entity fields (call sign, serial_number, unit_number)
            $scope.vehicle = {};
            var entityIdx = $scope.enterprise.entities.findIndex(function (item) {
                return item.id === '774e4ce2-2d43-43fa-b64d-c70eb53e81ee'; // vehicles id in Entity_Enterprise_Fields
            });
            var categoryIdx = $scope.enterprise.entities[entityIdx].categories.findIndex(function (item) {
                return item.id === 'ca1379c4-3660-4d31-9fda-d1ee60c7b807'; // details id in Entity_Categories
            });
            const len = $scope.enterprise.entities[entityIdx].categories[categoryIdx].fields.length;
            const fields = $scope.enterprise.entities[entityIdx].categories[categoryIdx].fields;

            for (var i = 0; i < len; i++) {
                if (fields[i].name === 'call_sign') {
                    $scope.vehicle.callSignName = fields[i].label;
                    $scope.vehicle.useCallSign = fields[i].public_portal;
                } else if (fields[i].name === 'serial_number') {
                    $scope.vehicle.serialNumberName = fields[i].label;
                    $scope.vehicle.useSerialNumber = fields[i].public_portal;
                } else if (fields[i].name === 'unit_number') {
                    $scope.vehicle.unitNumberName = fields[i].label;
                    $scope.vehicle.useUnitNumber = fields[i].public_portal;
                }
            }

            function getServiceApplicationVehicles() {
                $scope.appLoading = true;
                var licenseRequestIds = [];

                // If there's a service, grab formIds to see if they have 'service_vehicles' data set
                if ($scope.applications) {
                    for (var i = 0; i < $scope.applications.length; i++) {
                        if ($scope.applications[i].serviceId != null) {
                            licenseRequestIds.push($scope.applications[i].id);
                        }
                    }

                    // Find which forms have vehicles & collect the data
                    (function () {
                        FBResponses.getServiceApplicationVehicles(licenseRequestIds).then(function (dataSet) {
                            if (dataSet != null) {
                                // Create a dictionary of license_request_id's & the vehicle_count
                                var licenseRequestsAndVehicles = dataSet.reduce(function (acc, data) {
                                    if (acc[data.license_request_id]) {
                                        acc[data.license_request_id] += data.vehicle_count;
                                    } else {
                                        acc[data.license_request_id] = data.vehicle_count;
                                    }
                                    return acc;
                                }, {});

                                for (var i = 0; i < dataSet.length; i++) {
                                    // find index of application that needs vehicle data 
                                    var applicationIdx = $scope.applications.findIndex(function (item) {
                                        return item.id === dataSet[i].license_request_id;
                                    });

                                    // If license_request_id is in dictionary, add vehicle data
                                    if (licenseRequestsAndVehicles.hasOwnProperty(dataSet[i].license_request_id)) {
                                        $scope.applications[applicationIdx].vehicle = {};
                                        $scope.applications[applicationIdx].vehicle.vehicle_count = licenseRequestsAndVehicles[dataSet[i].license_request_id];
                                        if (dataSet[i].vehicle_count === 1) {
                                            $scope.applications[applicationIdx].vehicle.call_sign = dataSet[i].call_sign
                                            $scope.applications[applicationIdx].vehicle.serial_number = dataSet[i].serial_number
                                            $scope.applications[applicationIdx].vehicle.unit_number = dataSet[i].vehicle_unit_number
                                        }
                                    }
                                }
                            }
                            $scope.appLoading = false;
                        });
                    })(i);
                }
            }

            $scope.checkAllApplications = function (event, checkAll, applications) {
                event.stopImmediatePropagation();
                applications.forEach(function (application) {
                    application.inBulkApply = checkAll;
                    if (checkAll) {
                        //Add everything to bulk action if doesn't exist
                        if (!$scope.bulkActionApplications.includes(application.id)) {
                            $scope.bulkActionApplications.push(application.id);
                        }
                    }
                })
                if (!checkAll) {
                    //Clear everything
                    $scope.bulkActionApplications = [];
                }
            };

            $scope.applyOne = function (event, application) {
                event.stopImmediatePropagation();
                if (application.inBulkApply) {
                    //Add to bulk action list
                    $scope.bulkActionApplications.push(application.id);
                } else {
                    //Remove from bulk action list
                    var index = $scope.bulkActionApplications.indexOf(application.id);
                    $scope.bulkActionApplications.splice(index, 1);
                }
            };

            $scope.payApplications = function (bulkApply) {
                if ($scope.bulkActionApplications.length > 0) {
                    var applicationIds = $scope.bulkActionApplications.join(",");
                    $scope.bulkActionApplications = [];
                    bulkApply.isOpen = false;
                    $window.open($rootScope.portalURL + 'controller.cfm?method=public.reviewApplicationsPayment&bulkActionApplicationIds=' + applicationIds, '_self');
                }
                else {
                    alert("Please select one or more applications to pay for.");
                }
            };
        }])
    ;
